import {About, Home} from "../screens";
import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';
import Icon from 'react-native-vector-icons/FontAwesome5';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import {Favourites} from "../screens";
import LogoTitle from "../components/LogoTitle/LogoTitle";
import {Categories} from "../screens";
import React from "react";


const Tab = createBottomTabNavigator();
const MainStack = createNativeStackNavigator();

export default function Main({navigation,route}) {
    return (
        <MainStack.Navigator
            screenOptions={{
                headerShown: false,
            }}
            initialRouteName="BottomTabNavigator">
            <MainStack.Screen
                name="BottomTabNavigator"
                component={BottomTabNavigator}
            />
        </MainStack.Navigator>
    )
}

function BottomTabNavigator({navigation, route}){
    return(
        <Tab.Navigator
            screenOptions={{
                tabBarStyle: { marginBottom: 15 },
            }}
        >
            <Tab.Screen name="Home" component={Home}
                        initialParams={route.params}
                        options={{
                            title: ('Home'),
                            headerTitleAlign: 'center',
                            headerTitle: (props) => <LogoTitle title={route.params.appData.name}
                                                               logo={route.params.appData.logo}
                                                               color={route.params.appData.theme_colour}
                                                               {...props} />,
                            headerStyle: {
                                backgroundColor: '#fff'
                            },
                            tabBarActiveTintColor: route.params.appData.theme_colour,
                            tabBarInactiveTintColor: '#555555',
                            tabBarIcon: ({color}) => {
                                return <Icon solid name="home" size={18} color={color} />;
                            },
                            tabBarLabelStyle: {
                                fontSize: 11,
                                fontFamily: 'Raleway'
                            }
                        }}
            />
            <Tab.Screen name="Categories" component={Categories}
                        initialParams={route.params}
                        options={{
                            title: ('Categories'),
                            headerTitleAlign: 'center',
                            headerTitle: (props) => <LogoTitle title='Categories'
                                                               logo={route.params.appData.logo}
                                                               color={route.params.appData.theme_colour}
                                                               {...props} />,
                            tabBarIcon: ({color}) => {
                                return <Icon solid name="list-alt" size={18} color={color} />
                            },
                            tabBarActiveTintColor: route.params.appData.theme_colour,
                            tabBarInactiveTintColor: '#555555',
                            tabBarLabelStyle: {
                                fontSize: 11,
                                fontFamily: 'Raleway'
                            }
                        }}
            />
            <Tab.Screen name="Favourites" component={Favourites}
                        initialParams={route.params}
                        options={{
                            title: ('Favourites'),
                            headerTitleAlign: 'center',
                            headerTitle: (props) => <LogoTitle title='Favourites'
                                                               logo={route.params.appData.logo}
                                                               color={route.params.appData.theme_colour}
                                                               {...props} />,
                            tabBarIcon: ({color}) => {
                                return <Icon solid name="star" size={18} color={color} />
                            },
                            tabBarActiveTintColor: route.params.appData.theme_colour,
                            tabBarInactiveTintColor: '#555555',
                            tabBarLabelStyle: {
                                fontSize: 11,
                                fontFamily: 'Raleway'
                            }
                        }}
            />
            <Tab.Screen name="About" component={About}
                        initialParams={route.params}
                        options={{
                            headerShown:false,
                            tabBarIcon: ({color}) => {
                                return <Icon solid name="hand-holding-heart" size={18} color={color} />
                            },
                            tabBarActiveTintColor: route.params.appData.theme_colour,
                            tabBarInactiveTintColor: '#555555',
                            tabBarLabelStyle: {
                                fontSize: 11,
                                fontFamily: 'Raleway'
                            }
                        }}
            />
            {/*<Tab.Screen name="Inbox" component={Favourites}
                        initialParams={route.params}
                        options={{
                            title: ('Inbox'),
                            headerTitleAlign: 'center',
                            headerTitle: (props) => <LogoTitle title='Inbox'
                                                               logo={route.params.appData.logo}
                                                               color={route.params.appData.theme_colour}
                                                               {...props} />,
                            tabBarIcon: ({color}) => {
                                return <Icon solid name="comment-alt" size={18} color={color} />
                            },
                            tabBarActiveTintColor: route.params.appData.theme_colour,
                            tabBarInactiveTintColor: '#555555',
                            tabBarLabelStyle: {
                                fontSize: 11,
                                fontFamily: 'Raleway'
                            },
                            tabBarBadge: 3
                        }}
            /> */}
        </Tab.Navigator>
    )


}